/**
 * 鉴权 API —— 真实 JWT 登录（替换原 RoleContext 演示登录）。
 *
 * 后端登录白名单：/api/system/user/login（网关 WHITE_LIST，免鉴权）。
 * 响应 data：{ token, userId, username, orgId, platform }。
 *
 * 注：后端双 Token 设计声明了 /api/auth/refresh，但当前未暴露 controller 端点；
 * access token 有效期 24h，足以覆盖单班次，401 时前端引导重新登录即可（见 request.ts）。
 */
import { request, setToken, clearToken, getToken } from './request';

export interface LoginResult {
  token: string;
  userId: string;
  username: string;
  /** 真实姓名（中文展示名），后端优先返回 realName，为空时前端回退 username */
  realName?: string;
  orgId: string;
  platform: boolean;
}

export async function login(username: string, password: string): Promise<LoginResult> {
  const data = await request<LoginResult>('/system/user/login', {
    method: 'POST',
    body: { username, password },
  });
  if (data?.token) setToken(data.token);
  return data;
}

/** 退出：清本地 token（后端 /system/user/logout 幂等，可不等待）。 */
export function logout(): void {
  clearToken();
}

export function getAuthToken(): string | null {
  return getToken();
}
